import React from 'react';
import {useTranslation} from 'react-i18next';
import {ALL_PERIODS, getPeriodName} from '../../../periods';

export const PREVIOUS_PERIOD = 'PREVIOUS_PERIOD';
export const SAME_PERIOD_LAST_YEAR = 'SAME_PERIOD_LAST_YEAR';

// Los mismos que ofrece el Explorador (`DataExplorerHeader.renderPeriodOptions`): los de línea
// de control y los que dependen de otro período quedan afuera.
const EXCLUDED = ['THIS_PERIOD', 'THIS_PERIOD_TILL_YESTERDAY', 'SAME_PERIOD_LAST_YEAR', 'PREVIOUS_PERIOD',
                  '7_DAYS_BEFORE', '14_DAYS_BEFORE'];

/**
 * "Comparar con": Período anterior · Mismo período del año anterior · la lista completa.
 * Props: value (period snake_case | null), onChange(period), disabled
 */
export function ComparePeriodSelector({value, onChange, disabled = false}) {
    const {t} = useTranslation();
    const selected = (value && value.predefined_period) || PREVIOUS_PERIOD;
    const available = ALL_PERIODS.filter((p) => !EXCLUDED.includes(p));
    return (
        <select className="inf-compare-select" value={selected} disabled={disabled}
                onChange={(e) => onChange({type: 'RELATIVE', predefined_period: e.target.value})}>
            <option value={PREVIOUS_PERIOD}>{t('data_explorer.previous_period', 'Período anterior')}</option>
            <option value={SAME_PERIOD_LAST_YEAR}>{t('periods.same_period_last_year', 'Mismo período del año anterior')}</option>
            {available.map((period) => (
                <option key={period} value={period}>{getPeriodName(period, t)}</option>
            ))}
        </select>
    );
}
